import { Component } from '@angular/core';
import { POCReportService } from '../../poc-report/poc-report.component.service';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';
import { ActivatedRoute } from '@angular/router';
import { distinctUntilChanged, Subscription } from 'rxjs';

@Component({
  selector: 'app-residential-land-supply5-years',
  templateUrl: './residential-land-supply5-years.component.html',
  styleUrls: ['./residential-land-supply5-years.component.scss']
})
export class ResidentialLandSupply5YearsComponent {
  houseVillaChartLoading!: boolean;
  houseVillaChart: any = [];

  chartView = ReportsChartEnum;
  routeSub$: Subscription = new Subscription();
  constructor(private pocReportService: POCReportService,
    private activatedRoute: ActivatedRoute
  ) {

  }

  ngOnInit() {
    this.routeSub$ = this.activatedRoute.queryParams.pipe(
      distinctUntilChanged(),
    ).subscribe((params) => {
      this.getGraph();
    })

  }


  getGraph() {
    this.houseVillaChartLoading = true;
    this.pocReportService.getResidentialLandSupplyChart().subscribe(
      {
        next: (res: any) => {
          this.houseVillaChartLoading = false;
          if (res.status == 200) {
            this.houseVillaChart = res.data
              .filter((item: any) => Number(item?.count) > 0)
              .sort((a: any, b: any) => Number(a.year) - Number(b.year))
              .map((item: any) => ({
                category: String(item.year),
                value: item.count
              }));
          }
        },

        error: () => {
          this.houseVillaChart = [];
          this.houseVillaChartLoading = false;
        }
      }
    )
  }

  ngOnDestroy(): void {
    this.routeSub$?.unsubscribe();
  }
}
